/** Lightweight org pending-line total for the Inventory Missing badge. */
import { useCallback, useEffect, useState } from "react";
import { listManufacturingRecipePendingLineCounts } from "@/lib/manufacturingClient";

export function useManufacturingMissingCount(enabled: boolean) {
  const [total, setTotal] = useState(0);

  const reload = useCallback(async () => {
    if (!enabled) {
      setTotal(0);
      return;
    }
    const r = await listManufacturingRecipePendingLineCounts();
    if (!r.ok) {
      setTotal(0);
      return;
    }
    const fromTotal = typeof r.data.total === "number" ? r.data.total : null;
    if (fromTotal != null) {
      setTotal(fromTotal);
      return;
    }
    // Fallback for older responses without total.
    setTotal(Object.values(r.data.counts).reduce((n, c) => n + c, 0));
  }, [enabled]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { total, reload };
}
